import { Box, Button, Center, Text } from '@frontend/ui-library';

import { links } from '../../../constants';
import { getIdFromUrl } from '@frontend/utils';

interface NotFoundProps {
  onSuggestCurrencyClick: () => void;
  className?: string;
}

export const NotFound = ({
  onSuggestCurrencyClick,
  className,
}: NotFoundProps) => {
  const surveyLink = links.getCurrencyNetworkSurveyLink(getIdFromUrl());

  return (
    <Box mt="40" className={className}>
      <Center direction="column">
        <Box
          style={{
            fontSize: '72px',
            lineHeight: '72px',
          }}
          role="img"
          aria-label="sad face emoji"
        >
          😕
        </Box>
        <Text
          as="div"
          size="large"
          weight="600"
          mt="16"
          align="center"
          color="black"
        >
          No results
        </Text>
        <Text
          as="div"
          size="small"
          weight="400"
          mt="16"
          align="center"
          color="neutral-600"
        >
          Seems like we don’t have that currency yet
        </Text>
        <Button
          mt="24"
          fullWidth
          as="a"
          size="medium"
          target="_blank"
          href={surveyLink}
          key="suggest a currency"
          onClick={onSuggestCurrencyClick}
        >
          Suggest new currency or network
        </Button>
      </Center>
    </Box>
  );
};
